export default __webpack_public_path__ + "static/media/dots.859e83a3.svg";